import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';

interface StorageOptionCardProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  index: number;
}

export default function StorageOptionCard({ label, selected, onClick, index }: StorageOptionCardProps) {
  // 시각적 분리: 숫자/단위 분리 (예: 128 + GB)
  const match = String(label).trim().match(/^(\d+(?:\.\d+)?)\s*(TB|GB)$/i);
  const valueText = match ? match[1] : label;
  const unitText = match ? match[2].toUpperCase() : '';
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.08 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <Card
        onClick={onClick}
        sx={{
          cursor: 'pointer',
          height: '100%',
          border: '2px solid transparent',
          borderRadius: 4,
          background: selected
            ? 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #6366f1, #8b5cf6) border-box'
            : 'linear-gradient(white, white) padding-box, linear-gradient(135deg, rgba(0,0,0,0.08), rgba(0,0,0,0.08)) border-box',
          backgroundColor: 'transparent',
          backdropFilter: 'blur(20px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: selected
              ? '0 24px 48px rgba(99, 102, 241, 0.18), 0 12px 24px rgba(99, 102, 241, 0.12)'
              : '0 24px 48px rgba(0,0,0,0.08), 0 12px 24px rgba(0,0,0,0.06)',
            borderColor: 'transparent',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '3px',
            background: selected
              ? 'linear-gradient(90deg, #6366f1 0%, #8b5cf6 100%)'
              : 'transparent',
            transition: 'all 0.3s ease',
          }
        }}
      >
        <CardContent sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {match ? (
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
              <Typography
                variant="h3"
                sx={{
                  fontSize: '1.8rem',
                  fontWeight: 900,
                  color: selected ? '#6366f1' : '#1f2937',
                  lineHeight: 1,
                  letterSpacing: '-0.02em'
                }}
              >
                {valueText}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 800,
                  color: selected ? '#6366f1' : '#374151',
                  opacity: 0.9
                }}
              >
                {unitText}
              </Typography>
            </Box>
          ) : (
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.05rem',
                fontWeight: 800,
                color: selected ? '#6366f1' : '#1f2937',
                lineHeight: 1.3,
              }}
            >
              {label}
            </Typography>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}


